import { FieldLabel } from '../../../../components/Form';
import { Controller, useFormContext } from 'react-hook-form';
import { SlackDestinationRow } from '../../../../components/Scheduler/SlackDestinationRow';
import styled from 'styled-components';
import { theme } from '../../../../styles/theme';
import { INotificationSettingsForm } from '../types';
import EmailsNotificationsTarget from './EmailsNotificationsTarget';

const Targets = styled.div`
  display: flex;
  width: 464px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 4px;
  border: 1px solid ${theme.colors.grayscale300};
`;

const NotificationsTargets = () => {
  const { control } = useFormContext<INotificationSettingsForm>();

  return (
    <Targets>
      <span>
        <b>Notifications</b> (optional)
      </span>
      <EmailsNotificationsTarget />
      <Controller
        name={`slackDestination`}
        control={control}
        render={({ field }) => (
          <SlackDestinationRow
            value={field.value}
            onChange={field.onChange}
            label={
              <FieldLabel>
                Which Slack channel to send notifications to? (optional)
              </FieldLabel>
            }
            noMargin
          />
        )}
      />
    </Targets>
  );
};

export default NotificationsTargets;
